import {SAVE_ACTIVITY_NAME} from "./activityActionType";

export const saveActivities = (data) => {
    return{
        type : SAVE_ACTIVITY_NAME,
        payload: data
    }
};